import React from "react";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Alert,
    Stack,
    CircularProgress
} from "@mui/material";
import { api } from "../../services/api";
import { maskCNPJ } from "../../utils/mask";
import { validateBr } from 'js-brasil';
import AppNav from '../../components/appNav';

export default function Recipe() {
    const [cnpj, setCnpj] = React.useState("");
    const [events, setEvents] = React.useState([]);
    const [selectedEvent, setSelectedEvent] = React.useState("");
    const [inscriptions, setInscriptions] = React.useState([]);
    const [loadingEvents, setLoadingEvents] = React.useState(false);
    const [loadingInscriptions, setLoadingInscriptions] = React.useState(false);
    const [error, setError] = React.useState("");

    // Buscar eventos pelo CNPJ
    const handleSearchEvents = async () => {
        setError("");
        setEvents([]);
        setSelectedEvent("");
        setInscriptions([]);
        if (cnpj.replace(/\D/g, "").length !== 14 || !validateBr.cnpj(cnpj)) {
            setError("Digite um CNPJ válido.");
            return;
        }
        setLoadingEvents(true);
        try {
            const { data } = await api.get(`/order/company-events/${cnpj.replace('/', '%2F')}`);
            if (!data || data.length === 0) {
                setError("Nenhum evento encontrado para este CNPJ.");
                setLoadingEvents(false);
                return;
            }
            setEvents(data);
        } catch (err) {
            setError("Erro ao buscar eventos. Tente novamente.");
        }
        setLoadingEvents(false);
    };

    // Buscar inscrições do evento selecionado
    const handleSearchInscriptions = async () => {
        setError("");
        setInscriptions([]);
        if (!selectedEvent) {
            setError("Selecione um evento.");
            return;
        }
        setLoadingInscriptions(true);
        try {
            const { data } = await api.get(`/order/company-subscribers/${cnpj.replace('/', '%2F')}/${selectedEvent}`);
            if (!data || data.length === 0) {
                setError("Nenhuma inscrição encontrada para este evento.");
                setLoadingInscriptions(false);
                return;
            }
            setInscriptions(data);
        } catch (err) {
            setError("Erro ao buscar inscrições. Tente novamente.");
        }
        setLoadingInscriptions(false);
    };

    return (
        <React.Fragment>
            <AppNav />
            <Box sx={{ maxWidth: 900, margin: "auto", padding: 4 }}>
                <Typography variant="h4" align="center" gutterBottom fontWeight={700} color="#004D91">
                    Resolução de Recibos
                </Typography>
                <Paper elevation={3} sx={{ padding: 4, mb: 4 }}>
                    <Stack spacing={3}>
                        <TextField
                            label="CNPJ"
                            value={cnpj}
                            onChange={e => setCnpj(maskCNPJ(e.target.value))}
                            inputProps={{ maxLength: 18 }}
                            fullWidth
                            error={error}
                            helperText="Digite o CNPJ da empresa"
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSearchEvents}
                            disabled={loadingEvents || cnpj.replace(/\D/g, "").length !== 14}
                        >
                            {loadingEvents ? <CircularProgress size={24} /> : "Buscar Eventos"}
                        </Button>
                        {events.length > 0 && (
                            <TextField
                                select
                                label="Selecione o Evento"
                                value={selectedEvent}
                                onChange={e => setSelectedEvent(e.target.value)}
                                fullWidth
                                helperText="Escolha o evento para visualizar as inscrições"
                            >
                                {events.map(event => (
                                    <MenuItem key={event.id} value={event.id}>
                                        {event.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}
                        {selectedEvent && (
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSearchInscriptions}
                                disabled={loadingInscriptions}
                            >
                                {loadingInscriptions ? <CircularProgress size={24} /> : "Procurar Inscrições"}
                            </Button>
                        )}
                        {error && <Alert severity="error">{error}</Alert>}
                    </Stack>
                </Paper>

                {inscriptions.length > 0 && (
                    <Paper elevation={2} sx={{ padding: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Inscrições encontradas
                        </Typography>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Nome</b></TableCell>
                                        <TableCell><b>Número do Boleto</b></TableCell>
                                        <TableCell><b>Recibo</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {inscriptions.map((insc, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell>{String(insc.subscriber_name).toUpperCase()}</TableCell>
                                            <TableCell>{insc.external_id || 'Recibo indisponível'}</TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    href={`recibo/${insc.external_id}`}
                                                    target="_blank"
                                                    disabled={!insc.external_id}
                                                    rel="noopener noreferrer"
                                                >
                                                    Ver Recibo
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                )}
            </Box>
        </React.Fragment>
    );
};